import React, { Component } from 'react';
import { Grid, Icon, Form, Button, Modal, Segment, Dropdown, Header, Checkbox } from 'semantic-ui-react';
import { getUsers, deleteUsers, exportXLSX } from '../../utils/rest';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import { yesNo } from '../../utils/defaults';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import ChangePassword from './ChangePassword';
import Loading from '../Loading';
import MessageBox from '../../ui/MessageBox';
const initialState = {
  usrLocked: "",
  usrEmail: "",
  usrName: "",
  usrActive: ""
}
class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      deleteUserModal: false,
      changePasswordModal: false,
      users: [],
      usrId: 0,
      searchIndex: initialState,
      showCorporateUsers: false
    };
  }

  componentDidMount() {

    this.props.addItem("helpFile", "admin_users.md");
    this.loadUsers();
  }

  componentDidUpdate(prevProps) {
    if (this.props.items.currentCorporate !== prevProps.items.currentCorporate) {
      this.loadUsers();
    }
  }

  componentWillUnmount() {

    this.props.addItem("helpFile", null);
  }


  resetSearch = () => {
    this.setState((prevState, props) => {
      return {
        searchIndex: initialState
      };
    });
  }

  openDeleteModal = (id) => {
    this.setState((prevState, props) => {
      return { deleteUserModal: true, usrId: id };
    });
  }

  openChangePasswordModal = (id) => {
    this.setState((prevState, props) => {
      return { changePasswordModal: true, usrId: id };
    });
  }
  close = () => {
    this.setState((prevState, props) => {
      return { deleteUserModal: false, changePasswordModal: false };
    });
  }

  loadUsers = () => {
    this.setState((prevState, props) => {
      return { loading: true };
    }, () => {
      getUsers(this.props.items.currentCorporate, this.state.searchIndex, this.props.items.isInternalUser).then(response => {
        if (response !== null) {
          this.setState((prevState, props) => {
            return { users: response, loading: false };
          });
        }
      }).then((error) => {
        this.setState({
          loading: false
        });
      });
    });

  }

  deleteUser = () => {
    deleteUsers(this.state.usrId).then(response => {

      this.setState((prevState, props) => {
        return {
          users: this.state.users.filter((u) => {
            return u.usrId !== this.state.usrId;
          }), deleteUserModal: false
        };
      });
    });
  }

  toggleCheckBox = () => {
    const showCorporateUsers = !(this.state.showCorporateUsers);
    getUsers(this.props.items.currentCorporate, this.state.searchIndex, !showCorporateUsers).then(response => {
      if (response !== null) {
        this.setState((prevState, props) => {
          return { users: response, loading: false };
        });
      }
    }).then((error) => {
      this.setState({
        showCorporateUsers
      });
    });
  }

  handleChange = (e, data) => {
    this.setState({
      searchIndex: {
        ...this.state.searchIndex,
        [data.name]: data.value
      }
    });
  }

  render() {
    if (this.state.loading) {
      return (
        <Loading />
      )
    }
    const { users } = this.state;
    return (
      <div>
        <BreadcrumbCustom {...this.props} parent="Admnistration" child={[{ name: "Users", url: null }]} />
        <Grid className="g-bkgd">
          <Grid.Row>
            <Grid.Column>
              <Form className="small">
                <Form.Group widths='equal'>
                  <Form.Field width={4}>
                    <label>Email:</label>
                    <Form.Input placeholder='Email' onChange={this.handleChange} value={this.state.searchIndex.usrEmail} name="usrEmail" />
                  </Form.Field>
                  <Form.Field width={4}>
                    <label>Name:</label>
                    <Form.Input placeholder='First or Last Name Only' onChange={this.handleChange} value={this.state.searchIndex.usrName} name="usrName" />
                  </Form.Field>
                  <Form.Field width={3}>
                    <label>Lock Status:</label>
                    <Dropdown placeholder='Select' className="fluid" selection options={yesNo} value={this.state.searchIndex.usrLocked} onChange={this.handleChange} name="usrLocked"></Dropdown>
                  </Form.Field>
                  <Form.Field width={3}>
                    <label>Active Status:</label>
                    <Dropdown placeholder='Select' className="fluid" selection options={yesNo} value={this.state.searchIndex.usrActive} onChange={this.handleChange} name="usrActive"></Dropdown>
                  </Form.Field>
                  <Form.Field width={2}>
                    <Button.Group className="small push-down">
                      <Button onClick={this.resetSearch}>{this.props.t("reset")}</Button>
                      <Button.Or />
                      <Button positive onClick={this.loadUsers}>{this.props.t("submit")}</Button>
                    </Button.Group>
                  </Form.Field>
                </Form.Group>
              </Form>
              <Segment.Group raised>
                <Segment.Group horizontal>
                  <Segment color="grey" inverted>
                    <Header as="h4">
                      <Icon name="users" />
                      <div className="content">
                        Users
                       </div>
                    </Header>
                  </Segment>
                  <Segment color="grey" inverted>
                    <Button as={Link} to={"/user"} className="inverted right floated small">
                      Add a user
                      </Button>
                  </Segment>
                </Segment.Group>
                <Grid className="margin-bottom-5">
                  <Grid.Column width={6} floated='left' className="remvespace-btm push-down15">
                    {
                      (() => {
                        if (this.props.items.isInternalUser) {
                          return (
                            <Checkbox name="showCorporateUsers" onChange={this.toggleCheckBox} label="Show user(s) on current corporate" />
                          )
                        }
                      })()
                    }
                  </Grid.Column>
                  <Grid.Column width={1} floated='right' className="remvespace-btm">
                    <Button onClick={() => {
                      exportXLSX(
                        {
                          "Login Name": "usrUserName",
                          "First Name": "usrFirstName",
                          "Last Name": "usrLastName",
                          "Email": "usrEmail",
                          "Internal": "usrInternal",
                          "Lock Status": "usrLocked"

                        }, users, "Users.xlsx")
                    }}
                      className="ui left small icon button icon-export " data-inverted="" data-tooltip="Export Table Details to Spreadsheet" data-position="bottom right">
                      <i className="file excel icon"></i>
                    </Button>
                  </Grid.Column>
                </Grid>
                <ReactTable minRows={0} filterable defaultPageSize={this.props.reactTable().pageSize} showPagination={users.length > this.props.reactTable().pageSize ? true : false} defaultFilterMethod={this.props._customFilter} className="celled -striped -highlight "
                  data={users}
                  getNoDataProps={() => {
                    return { style: { display: 'none' } };
                  }}
                  columns={[{
                    Header: props => <span data-inverted="" data-tooltip="The User Name" data-position="bottom left">Login Name</span>,
                    accessor: 'usrUserName' // String-based value accessors!
                  }, {
                    Header: props => <span data-inverted="" data-tooltip="The User FirstName" data-position="bottom left">{this.props.t("firstname")}</span>,
                    accessor: 'usrFirstName',
                  }, {
                    Header: props => <span data-inverted="" data-tooltip="The User LastName" data-position="bottom left">{this.props.t("lastname")}</span>,
                    accessor: 'usrLastName',
                  }, {
                    Header: props => <span data-inverted="" data-tooltip="The User Email" data-position="bottom left">Email</span>,
                    accessor: 'usrEmail',
                  }, {
                    Header: props => <span data-inverted="" data-tooltip="The User is internal or client user" data-position="bottom right">Internal</span>,
                    id: 'usrInternal',
                    width: 100,
                    style: {
                      textAlign: "center"
                    },
                    accessor: row => (
                      row.usrInternal === 'Y' ? "Yes" : "No"
                    )
                  }, {
                    Header: props => <span data-inverted="" data-tooltip="Has a lock been placed on the user’s account?" data-position="bottom right">Lock Status</span>,
                    id: 'usrLocked',
                    width: 90,
                    style: {
                      textAlign: "center"
                    },
                    filterable: false,
                    accessor: row => (
                      row.usrLocked === 'Y' ? <Icon name="lock" /> : <Icon name="unlock" />
                    )
                  }, {
                    Header: props => <span data-inverted="" data-tooltip="Has user’s account is deactivated?" data-position="bottom right">Active Status</span>,
                    id: 'usrActive',
                    width: 90,
                    style: {
                      textAlign: "center"
                    },
                    filterable: false,
                    accessor: row => (
                      row.usrActive === 'Y' ? "Yes" : "No"
                    )
                  }, {
                    Header: props => <span data-inverted="" data-tooltip="Clickable Action Buttons" data-position="bottom right">{this.props.t("actions")}</span>,
                    filterable: false,
                    width: 130,
                    style: {
                      textAlign: "center"
                    },
                    Cell: row => (
                      <div>
                        <Button as={Link} to={"/user/" + row.original.usrId} className="icon mini" data-tooltip="Edit user" data-inverted="" data-position="top right" ><Icon name="pencil alternate" /></Button>
                        <Button onClick={() => this.openChangePasswordModal(row.original.usrId)} className="icon mini" data-inverted="" data-tooltip="Change Password" data-position="top right"><Icon name="key" /></Button>
                        <Button onClick={() => this.openDeleteModal(row.original.usrId)} className="icon mini" data-inverted="" data-tooltip="Delete User" data-position="top right"><Icon name="trash alternate outline" /></Button>
                      </div>
                    )
                  }]}
                />
              </Segment.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <MessageBox {...this.props} box={12} size="tiny" open={this.state.deleteUserModal} close={this.close} contentTitle="Delete User?" content="Are you sure you want to delete this user?" yesHandle={this.deleteUser} />
        <Modal size="small" open={this.state.changePasswordModal} onClose={this.close} closeIcon>
          <Modal.Header><Icon name="key"></Icon>Change Password?</Modal.Header>
          <Modal.Content>
            <ChangePassword {...this.props} usrId={this.state.usrId} modalClose={this.close} />
          </Modal.Content>
          <Modal.Actions>
            <Button.Group width={2} className="small buttons">
              <Button onClick={this.close}>{this.props.t("close")}</Button>
            </Button.Group>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}
export default User;


// WEBPACK FOOTER //
// ./src/app/ui/administrations/User.js